/* eslint-disable */

import React, { createContext, useCallback, useMemo, useState } from 'react';

export const ModalContext = createContext(null);

const DEFAULTS = {
	type: 'warning', // 'error' | 'success' | 'info' | 'warning'
	title: '',
	description: '',
	okText: 'OK',
	cancelText: null, // null = tidak tampilkan tombol cancel
	onOk: null,
	onCancel: null,
	closable: true,
	maskClosable: false,
};

export default function ModalProvider({ children }) {
	const [visible, setVisible] = useState(false);
	const [modalProps, setModalProps] = useState(DEFAULTS);

	const closeModal = useCallback(() => {
		setVisible(false);
		setModalProps(DEFAULTS);
	}, []);

	const openModal = useCallback((opts = {}) => {
		// normalize props + defaulting by type
		const next = { ...DEFAULTS, ...opts };
		if (next.type === 'error' && !next.okText) next.okText = 'OK, Mengerti';
		if (next.type === 'success' && !next.okText) next.okText = 'Selesai';

		setModalProps(next);
		setVisible(true);
	}, []);

	const value = useMemo(
		() => ({ visible, modalProps, openModal, closeModal }),
		[visible, modalProps, openModal, closeModal]
	);

	return (
		<ModalContext.Provider value={value}>{children}</ModalContext.Provider>
	);
}
